<template>
  <v-container class="fuel-component mt-1 pa-0 pr-2 pl-3">
    <v-row class="pa-0" v-if="!horometro.notApply" align="center">
      <v-col
        v-if="isEditChecklist"
        align-self="center"
        class="pa-3 py-4 fuel-component_not-apply text-center"
        cols="2"
        @click.stop="horometro.notApply = !horometro.notApply"
        >No aplica</v-col
      >
      <v-col cols="6" class="pa-0 pl-2 pr-3">
        Horómetro
        <div>
          <v-text-field
            class="ma-0 pa-0"
            :disabled="accessToEdit || !isEditChecklist"
            v-model="horometro.value"
            required
            type="number"
            hide-details
            :rules="fieldRequired"
            filled
          ></v-text-field>
        </div>
      </v-col>
      <v-col :cols="!isEditChecklist ? 6 : 4" class="py-0">
        <v-card text tile class="actual-state__single-image" white>
          <v-container fluid fill-height class="pa-0">
            <v-row
              no-gutters
              column
              class="text-center justify-space-between fill-height"
            >
              <template v-if="horometro.image" class="text-center">
                <v-icon
                  v-if="isEditChecklist"
                  class="actual-state__icon-delete"
                  color="accent"
                  dense
                  size="16"
                  @click.prevent="deleteAndCleanImage()"
                  >fas fa-plus</v-icon
                >
                <img
                  :src="validSrcImage(horometro.image)"
                  class="actual-state__image"
                  alt="Image to upload"
                  @click="downloadImage(horometro.image)"
                />
                <v-col
                  tag="div"
                  block
                  class="text-center actual-state__image-text pa-0"
                  cols="12"
                  >Horómetro</v-col
                >
              </template>
              <template v-else>
                <v-icon
                  class="actual-state__icon"
                  color="gray"
                  @click.prevent="uploadImage()"
                  @onUpload="startImageResize"
                  @onComplete="endImageResize"
                  >fas fa-plus</v-icon
                >
                <template slot="loading">
                  <v-progress-circular
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </template>
                <v-col
                  tag="div"
                  block
                  class="text-center actual-state__image-text pa-0"
                  cols="12"
                >
                  Horómetro
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="pa-3" v-else no-gutters>
      <v-col align-self="center" class="pa-2" cols="11" md="11" align="center"
        >No aplica el horometro en este modelo</v-col
      >
      <v-col align-self="center" align="center" cols="1" md="1">
        <v-icon
          class="fuel-component_icon"
          color="gray"
          dense
          size="16"
          v-if="isEditChecklist"
          @click.stop="horometro.notApply = !horometro.notApply"
          >fas fa-plus</v-icon
        >
      </v-col>
    </v-row>
    <input
      :disabled="accessToEdit"
      v-show="false"
      ref="uploadHorometro"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadHorometro.files)"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { ResizeImage } from "@/services/ResizeImage";
import { loaderDone, loaderStart } from "@/services/LoaderService";

export default {
  data() {
    return {
      labels: ["E", "1/4", "1/2", "3/4", "F"],
      fieldRequired: [v => !!v || "Ingrese el valor correspondiente"]
    };
  },
  props: ["isEditChecklist", "accessToEdit"],
  computed: {
    ...mapState("checklist", ["horometro"])
  },
  methods: {
    validSrcImage(url) {
      if (!this.isEditChecklist) {
        if (!url) return null;
        if (url.includes("https")) return url;
        return require("@/assets/logo.png");
      }
      return url;
    },
    uploadImage() {
      this.$refs.uploadHorometro.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        this.horometro.image = resizedImage;
        this.$refs.uploadHorometro.value = null;
      }
    },
    downloadImage(url) {
      window.open(url, "_blank");
    },
    deleteAndCleanImage() {
      this.horometro.image = null;
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    }
  }
};
</script>

<style scoped>
.fuel-component {
  size: 10px;
  border: 0.3px solid #a0a0a0;
}
.fuel-component_not-apply {
  background-color: lightgray;
}
.fuel-component_icon {
  padding: 0;
  margin: 0;
  transform: rotate(45deg);
}
.actual-state {
  border: 1px solid lightgray;
}
.actual-state__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 70px;
  max-width: 200px;
  margin: 0 auto;
}
.actual-state__icon {
  padding: 12px;
  margin: 0 auto;
}
.actual-state__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
}
.actual-state__image {
  max-height: 103px;
  object-fit: contain;
  margin: 0;
  height: 80%;
  padding: 0 4px;
  overflow: hidden;
  width: 100%;
}
.actual-state__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
</style>
